module.exports = function() {
  return new Worker(__webpack_public_path__ + "9ecd076c9f1677d109bd.worker.js");
};


//////////////////
// WEBPACK FOOTER
// ./src/js/libs/pcm-play.worker.js
// module id = 177
// module chunks = 1 2